import {useEffect, useState} from 'react';
import {HttpCLG} from '../api/HttpCLG';
import {CLGDetalleFila} from '../components/SeccionCLGDatosDetalle';
import {
    OperacionCLGDetalleFields,
    OperacionCLGLimitesAprobadosPaisFields,
    OperacionCLGSectorComercialFields,
} from '../types/fields';
import {CLGLimitesAprobadosPais, OperacionCLGLimitesSectorComercial} from '../types/types'; // Asegúrate que la ruta a los tipos es correcta
import {EntityWithIdFields, QueryStatus} from "../../../../../types";
import {FormFiltros} from "../../../../limites/FiltrosBusqueda";

export interface CLGLimitesPorSectorComercial {
    sector: OperacionCLGLimitesSectorComercial;
    aforos: CLGDetalleFila[][];
}

export interface CLGLimitesPorPais {
    pais: CLGLimitesAprobadosPais;
    sectores: CLGLimitesPorSectorComercial[];
}

export const useLimiteCLG = (filtros: FormFiltros) => {
    const [data, setData] = useState<CLGLimitesPorPais[]>([]);
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle);

    const fetch = () => {
        setStatus(QueryStatus.Loading);

        HttpCLG.getLimites(filtros).then((response: CLGLimitesAprobadosPais[]) => {
            if (response.length === 0) {
                setData([]);
                setStatus(QueryStatus.Success);

                return;
            }

            // nivel pais
            const paisesProcesados = response.map(paisGroup => {

                // para cada pais iteramos sobre la lista de sectores comerciales
                const sectoresProcesados = paisGroup[OperacionCLGLimitesAprobadosPaisFields.ListaSectores].map(sectorGroup => {

                    const limitesDelSector = sectorGroup[OperacionCLGSectorComercialFields.ListaLimites];

                    // los aforos vienen en una lista pero tenemos que mostrarlos en una tabla, por eso lo transformamos en una matriz 2d
                    // el array exterior agrupa por 'CabeceraDetalle' (p.ej. cauciones mae) y el interior por 'especie' (p.ej. t-bills)
                    const aforosTransformados: CLGDetalleFila[][] = limitesDelSector.reduce<CLGDetalleFila[][]>((acc, item) => {
                        const existingGroup = acc.find(group => group[0].ordenCabeceraDetalle === item.ordenCabeceraDetalle);
                        const existingItem = existingGroup?.find(x => x.especie === item.especie);
                        const aforo = {
                            id: item.id,
                            [OperacionCLGDetalleFields.Aforo]: item[OperacionCLGDetalleFields.Aforo],
                            [OperacionCLGDetalleFields.OrdenSeccion]: item[OperacionCLGDetalleFields.OrdenSeccion],
                            [OperacionCLGDetalleFields.Sector]: item[OperacionCLGDetalleFields.Sector],
                            [OperacionCLGDetalleFields.PermiteModificar]: false,
                            [OperacionCLGDetalleFields.CodEspecie]: item[OperacionCLGDetalleFields.CodEspecie],
                            [OperacionCLGDetalleFields.Especie]: item[OperacionCLGDetalleFields.Especie],
                            [OperacionCLGDetalleFields.CodSeccion]: item[OperacionCLGDetalleFields.CodSeccion]
                        };
                        const newItem = {
                            [EntityWithIdFields.Id]: item[EntityWithIdFields.Id],
                            [OperacionCLGDetalleFields.IdOperacion]: item[OperacionCLGDetalleFields.IdOperacion],
                            [OperacionCLGDetalleFields.IdCabecera]: item[OperacionCLGDetalleFields.IdCabecera],
                            [OperacionCLGDetalleFields.Especie]: item[OperacionCLGDetalleFields.Especie],
                            [OperacionCLGDetalleFields.OrdenEspecie]: item[OperacionCLGDetalleFields.OrdenEspecie],
                            [OperacionCLGDetalleFields.OrdenCabecera]: item[OperacionCLGDetalleFields.OrdenCabecera],
                            listaAforo: [aforo]
                        };

                        if (existingItem) {
                            existingItem.listaAforo.push(aforo);
                        } else {
                            if (existingGroup) {
                                existingGroup.push(newItem);
                            } else {
                                acc.push([newItem]);
                            }
                        }

                        return acc;
                    }, []);

                    // para que orden de aforos sea para todos iguales
                    aforosTransformados.forEach(detailGroup => {
                        detailGroup.forEach(item => {
                            item.listaAforo.sort((a, b) => a[OperacionCLGDetalleFields.OrdenSeccion] - b[OperacionCLGDetalleFields.OrdenSeccion]);
                        });
                        detailGroup.sort((a, b) => a[OperacionCLGDetalleFields.OrdenEspecie] - b[OperacionCLGDetalleFields.OrdenEspecie]);
                    });
                    aforosTransformados.sort((a, b) => a[0][OperacionCLGDetalleFields.OrdenCabecera] - b[0][OperacionCLGDetalleFields.OrdenCabecera]);

                    return {
                        sector: sectorGroup,
                        aforos: aforosTransformados
                    };
                });

                return {
                    pais: paisGroup,
                    sectores: sectoresProcesados
                };
            });

            setData(paisesProcesados);
            setStatus(QueryStatus.Success);
        }).catch(error => {
            console.error('Error al obtener límites CLG:', error);
            setStatus(QueryStatus.Error);
        });
    }

    useEffect(() => {
        fetch();
    }, [filtros]);

    return {
        data,
        refetch: fetch,
        status
    };
}